// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';
import 'fg-frontend/plugins/jquery.gtmHandler';

let afterAjaxRequest = false;
$(document).on('ajaxComplete', function () {
  afterAjaxRequest = true;
});

// reset for turbolinks
document.addEventListener('turbolinks:render', () => {
  if 	(afterAjaxRequest) {
    afterAjaxRequest = false;
  }
});

export default class GtmHandler extends WebComponent {
  didMount() {
    $(this.element).gtmHandler({
      'debug':    false,
      'ajaxLoad': afterAjaxRequest,
    });
  }
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GtmHandler.js